import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import BackComponent from 'screens/back';
import { Table, Pagination, Tooltip, Input, CheckboxTable, Modal, Select, DatePicker } from 'components';
import { Globals, checkPermission, Constants, Print } from 'utils';
import { ReportService } from 'services';
import moment from 'moment';
import { CleanIcon, ExcelIcon } from 'assets/icons';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {

}

declare var window: any;

class PlanningReport extends React.Component<Props> {

	timer: any = undefined;

	state = {
		form: INITIAL_STATE,
		page: 1,
		last_page: 1,
		data: [],
		header: [
			'Item',
			'#Orden',
			'Fecha',
			'Cliente',
			'Contacto',
			'Dirección/Zona',
			'Tipo Servicio',
			'Precio',
			'Talento(s) Asignado(s)',
			'Forma de Pago',
			'Observaciones',
			'Ruta'
		],
		per_page: 0
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Reporte de Planificación',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
	}

	load = async (withoutLoading: boolean = false) => {
		const res: any = await ReportService.admin.getPlanning({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
		});
		this.setState({
			data: res.quotes.rows,
			last_page: res.quotes.count,
			per_page: res.per_page
		});
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	download = async () => {
		const res: any = await ReportService.admin.downloadPlanning({
			...this.state.form,
		});
		if (window.webkit && window.webkit.messageHandlers) {
			const message = 'open_url';
			const sendToNative = {
				message,
				url: Constants.BASE_STORAGE + res.url
			}
			const stringifiedMessageObj = JSON.stringify(sendToNative);
	        window.webkit.messageHandlers.cordova_iab.postMessage(stringifiedMessageObj);
	    }
	    else {
	    	Print(Constants.BASE_STORAGE + res.url);
	    }
	}

	render() {
		return (
			<div id="admin-reports-planning">
				<div className="row">
					<div className="col-md-6">
						<BackComponent />
					</div>
					<div className="col-md-6 text-right">
						<button className="btn btn-add btn-excel" onClick={ () => this.download() }>
							Descargar
							<img src={ ExcelIcon } />
						</button>
					</div>
				</div>

				<Table data={ this.state.data.length } header={ this.state.header }>
					{ this.state.data.map((i: any,index: number) => {
						return (
							<tr key={ index }>
								<td>{ index + 1 + this.state.per_page }</td>
								<td>{ i.number }</td>
								<td>{ moment(i.date).format('DD/MM/YYYY') }</td>
								<td>{ i.user?.full_name || '-' }</td>
								<td>{ i.user?.phone || '-' }</td>
								<td>{ i.city }</td>
								<td>{ i.service?.type_id == Constants.SERVICE_TYPES.CLEAN ? i.type?.name : '-' }</td>
								<td style={{ whiteSpace: 'nowrap' }}>{ Globals.formatMiles(i.price) }</td>
								<td>{ i.operators?.length > 0 ? i.operators?.map((i: any) => i.operator?.full_name).join(', ') : '-' }</td>
								<td>{ i.price > 0 ? i.payment_method?.name : '-' }</td>
								<td>{ i.planning_comments }</td>
								<td>{ i?.route?.name }</td>
							</tr>
						)
					}) }
				</Table>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(PlanningReport);